import * as React from 'react';
import themePrimary from '../../styles/themePrimary';
import { Typography, makeStyles } from '@material-ui/core';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import { String_PaymentConfirm_PaymentAgreement, String_PaymentConfirm_PaymentAgreementTerms } from '../../utilities/StringHelper';
import { ElementDimensions } from '../../styles/ElementDimensions';
import TermsPopup, { TermsPopupProps } from './TermsPopup';
import { UserStateContext } from '../../providers/UserStateContextProvider';
import { CheckStateContext } from '../../providers/CheckStateContextProvider';

const useStyles = makeStyles({
    instructionsContainer: {
        marginTop: ElementDimensions.margin20 + 'px',
        marginBottom: ElementDimensions.margin20 + 'px',
    },
    restaurantName: {
        textTransform: 'uppercase',
    },
    root: {
        textAlign: 'center',
        overflow: 'scroll',
    },
    sigContainer: {
        width: '90%',
        height: '150px',
        margin: '0 auto',
        border: '2px solid ' + themePrimary.palette.secondary.contrastText,
        backgroundColor: themePrimary.palette.primary.contrastText,
    },
    sigPad: {
        width: '95%',
        height: '95%',
    },
    termsText: {
        textDecoration: 'underline',
    },
    total: {
        fontWeight: 'bold',
    },
});

export default function PaymentTerms() {
    const [termsPopupOpen, setTermsPopupOpen] = React.useState(false);
    const userState = React.useContext(UserStateContext);
    const checkOutState = React.useContext(CheckOutStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });

    const showTermsPopup = () => {
        setTermsPopupOpen(true);
    }

    const handleTermsPopupCloseClick = (event: React.MouseEvent<HTMLElement>) => {
        setTermsPopupOpen(false);
    }

    const termsPopupProps: TermsPopupProps = {
        open: termsPopupOpen,
        onCloseHandler: handleTermsPopupCloseClick,
    }

    return (
        <div className={classes.root}>
           <div>
                <div className={classes.instructionsContainer}>
                    <Typography variant='body1'>
                        {String_PaymentConfirm_PaymentAgreement.find(s => s.key === userState.state.locale)!!.value}
                        <span onClick={showTermsPopup} className={classes.termsText}>
                            {String_PaymentConfirm_PaymentAgreementTerms.find(s => s.key === userState.state.locale)!!.value}
                        </span>
                    </Typography>
                </div>
            </div>

            <TermsPopup 
                open={termsPopupProps.open}
                onCloseHandler={termsPopupProps.onCloseHandler} />
        </div>
    );
}